import React, { useState } from "react";
import axios from "axios";
import "../App.css";
import { toast } from "react-toastify";

function Login() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!userName || !password) {
      toast.error("Username and password are required.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/login`, {
        userName,
        password,
      });

      if (response.data.success) {
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        toast.success("Login successful!");

        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 1500);
      } else {
        toast.error(response.data.message || "Login failed.");
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error(err.response?.data?.message || "Server error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-left">
          <img
            src={require("../img/tmis_logo_orig.png")}
            alt="TMIS Logo"
            width={200}
            className="mb-4 mx-auto d-block"
          />
          <h4 className="fw-bold text-center">LOG IN</h4>
          <input
            type="text"
            placeholder="Username"
            className="login-input"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button className="login-button" onClick={handleLogin} disabled={loading}>
            {loading ? "Logging in..." : "Log in"}
          </button>
        </div>
        <div className="login-right">
          <img
            src={require("../img/Singapore.jpg")}
            alt="Login Illustration"
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  );
}

export default Login;
